import script from "./LegalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalInfo.vue?vue&type=script&setup=true&lang=js"

import "./LegalInfo.vue?vue&type=style&index=0&id=8064a07c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8064a07c"]])

export default __exports__